import { useState } from "react";

const useCloseKycState = () => {
  const [requestType, setRequestType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageName, setPageName] = useState("RequestType");
  const [activeUserDetail, setActiveUserDetail] = useState(null);
  const [dematInfo, setDematInfo] = useState(null);

  return {
    requestType,
    setRequestType,
    isLoading,
    setIsLoading,
    pageName,
    setPageName,
    activeUserDetail,
    setActiveUserDetail,
    dematInfo,
    setDematInfo,
  };
};

export default useCloseKycState;
